import {getCurrentYear} from '../../utils/commons'
import TheMobileInsiderLogo from './logo'
import {theMobileInsiderStylesUS} from './styles'

const baseConfig = {
  domainName: 'themobileinsider' as const,
  domainType: 'insider' as const,
  siteName: 'The Mobile Insider',
  logo: <TheMobileInsiderLogo className="size-9 shrink-0 tablet:size-7" />,
  favicon: '/favicons/themobileinsider.png',
}

const localeConfigs = {
  us: {
    measurementId: 'G-FZSSZ09HNT',
    camelCaseUrl: 'TheMobileInsider.com',
    title: (category: string, _count: string) =>
      `Top-Rated ${category} of ${getCurrentYear()} | In-Depth Reviews & Analysis | TheMobileInsider.com`,
    description: (_category?: string, _count?: string) =>
      `Explore detailed product analyses and comprehensive reviews at TheMobileInsider.com. Find the most recommended mobile phones, devices, and accessories based on expert and user insights.`,
    styles: theMobileInsiderStylesUS,
  },
}

export const createConfig = (locale: string = 'us') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.us
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
